import { createPortal } from "react-dom";

/**
 * ModalPortal — renders children directly under <body> to escape any
 * ancestor that establishes a containing block for fixed-positioned
 * descendants (e.g. `.card:hover` in index.css applies `transform`,
 * which turns the card into the containing block and clips
 * `fixed inset-0` overlays to the card's bounding box).
 *
 * Usage:  return <ModalPortal><div className="fixed inset-0…">…</div></ModalPortal>
 */
export default function ModalPortal({ children }) {
  if (typeof document === "undefined") return null;
  return createPortal(children, document.body);
}
